import {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Who from './Who';

const withContact = (Slide, isEndUser) => {
  return (props) => {
    const {onBack, session, setLoading, clearLoading} = props;

    const services = useContext(ServiceContext);
    const [contact, setContact] = useState(null);
    const idRef = useRef('');

    const handleBack = useCallback((destination) => onBack(destination, isEndUser ? {
      selectedEndUser: null
    } : {
      selectedContact: null
    }), [onBack])

    useEffect(() => {
      if (session) {
        const id = isEndUser ?
          (session.selectedEndUser?.id ? `${session.selectedEndUser.id}` : '') :
          (session.selectedContact?.id ? `${session.selectedContact.id}` : '');
        if (id && id !== idRef.current) {
          idRef.current = id;
          setLoading(`Loading ${isEndUser ? 'End User' : 'Contact'} Details`);
          services.contact.getContact(id).then((retrieved) => {
            setContact(retrieved);
            clearLoading();
          }).catch(() => {
            clearLoading();
            handleBack({type: Who.type, id: Who.type});
          });
        }
      }
    }, [services, session, setLoading, clearLoading, handleBack]);

    return <Slide contact={contact} goBackWithoutContact={handleBack} isEndUser={isEndUser} {...props}/>;
  }
};

export default withContact;
